<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="d-flex justify-content-between">
          <h5 class="mb-4">
            <strong>Tambah Artikel Baru</strong>
          </h5>
          <a-radio-group v-model="category">
            <a-radio-button value="umum"> Artikel Umum </a-radio-button>
            <a-radio-button value="khusus"> Artikel Khusus </a-radio-button>
          </a-radio-group>
        </div>
        <a-form :form="form" @submit="handleSubmit">
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Judul Artikel"
          >
            <a-input
              :disabled="submitting"
              placeholder="Judul Artikel"
              v-decorator="[
                'title',
                {
                  rules: [
                    { required: true, message: 'Judul artikel harus diisi!' },
                  ],
                },
              ]"
            />
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Isi Artikel"
          >
            <a-radio-group v-model="textEditor">
              <a-radio-button value="rte"> Rich Text Editor </a-radio-button>
              <a-radio-button value="ta"> Text Area </a-radio-button>
            </a-radio-group>
            <a-textarea
              rows="6"
              :disabled="submitting"
              placeholder="Isi Artikel"
              v-decorator="['body']"
              v-if="textEditor == 'ta'"
            />
            <editor
              v-model="articleBody"
              v-if="textEditor == 'rte'"
              apiKey="v4o73bx9umvdzvgxil8eah6wgqbg3zz251aygdfvekzx7tbb"
              :init="{
                fontsize_formats: `8pt 10pt 12pt 14pt 17pt 18pt 24pt 26pt 36pt`,
                font_formats: `Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Montserrat=montserrat; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats`,
                content_style: `@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@700&display=swap');`,
                height: 500,
                menubar: false,
                plugins: [
                  'advlist autolink lists link image charmap textcolor image code',
                  'searchreplace visualblocks code fullscreen',
                  'print preview anchor insertdatetime media',
                  'paste code help wordcount table',
                ],
                toolbar: `undo redo | fontselect | link image | fontsizeselect | formatselect | bold italic | styleselect fontselect fontsizeselect | forecolor backcolor \
                  alignleft aligncenter alignright | \
                  table tabledelete | tableprops tablerowprops tablecellprops | tablemergecells | tablecellbordercolor | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol \
                  bullist numlist outdent indent | help`,
              }"
            >
            </editor>
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Gambar"
          >
            <a-upload
              :multiple="false"
              v-decorator="[
                'image',
                {
                  valuePropName: 'image',
                  rules: [
                    { required: true, message: 'Gambar artikel harus diisi!' },
                  ],
                },
              ]"
              name="upload"
              :action="action"
              list-type="picture"
              :file-list="fileList"
              @change="handleChange"
            >
              <a-button> <a-icon type="upload" /> Click to upload </a-button>
            </a-upload>
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Thumbnail"
          >
            <a-upload
              :multiple="false"
              v-decorator="[
                'thumbnailImage',
                {
                  valuePropName: 'thumbnailImage',
                  rules: [
                    {
                      required: true,
                      message: 'Thumbnail artikel harus diisi!',
                    },
                  ],
                },
              ]"
              name="upload"
              :action="actionThumbnail"
              list-type="picture"
              :file-list="fileList2"
              @change="handleChange2"
            >
              <a-button> <a-icon type="upload" /> Click to upload </a-button>
            </a-upload>
            <span class="font-italic font-weight-bold">
              <span class="text-danger"> * </span> Ukuran thumbnail max 540 x
              240 pixels
            </span>
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Penulis"
          >
            <a-input
              :disabled="submitting"
              placeholder="Penulis"
              v-decorator="[
                'writer',
                {
                  rules: [{ required: true, message: 'Penulis harus diisi!' }],
                },
              ]"
            />
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Tags"
          >
            <a-select
              mode="tags"
              style="width: 100%"
              :token-separators="[',']"
              v-decorator="['tags']"
            >
            </a-select>
            <span class="font-italic font-weight-bold">
              <span class="text-danger"> * </span> Tekan enter setelah
              menambahkan tag baru.
            </span>
          </a-form-item>
          <a-form-item
            v-if="category === 'khusus'"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Program"
          >
            <a-select
              style="width: 100%"
              v-decorator="[
                'tag',
                {
                  rules: [{ required: true, message: 'Program harus diisi!' }],
                },
              ]"
            >
              <a-select-option
                v-for="(pro, i) in programTypes"
                :key="i"
                :value="pro.name"
                >{{ pro.name }}</a-select-option
              >
              <!-- <a-select-option value="TAGRISSO"> TAGRISSO </a-select-option>
              <a-select-option value="FASLODEX"> FASLODEX </a-select-option>
              <a-select-option value="LYNPARZA"> LYNPARZA </a-select-option> -->
            </a-select>
          </a-form-item>
          <button
            type="submit"
            class="btn btn-success px-5"
            :disabled="submitting"
          >
            Simpan Data
          </button>
        </a-form>
      </div>
    </div>
  </div>
</template>
<script>
import router from '@/router'
import { create } from '@/services/axios/api/artikel'
import { notification } from 'ant-design-vue'
import { BASE_URL } from '@/config'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import Editor from '@tinymce/tinymce-vue'
import apiClient from '../../../services/axios'

const labelCol = {
  xs: { span: 24 },
  sm: { span: 4 },
}
const wrapperCol = {
  xs: { span: 24 },
  sm: { span: 12 },
}
export default {
  data: function () {
    return {
      form: this.$form.createForm(this),
      labelCol,
      wrapperCol,
      cityList: [],
      submitting: false,
      category: 'umum',
      textEditor: 'ta',
      // action: `${BASE_URL}/upload/news`,
      action: `${BASE_URL}/upload/news`,
      // actionThumbnail: `${BASE_URL}/upload/thumbnail`,
      actionThumbnail: `${BASE_URL}/upload/thumbnail`,
      fileList2: [],
      fileList: [],
      editor: ClassicEditor,
      articleBody: `<p style="text-align: center;"><span style="color: #ec008c; font-family: montserrat;"><strong><span style="font-size: 17pt;">Bagaimana cara menyimpan</span><br /><span style="color: #ec008c; font-family: montserrat;"><strong><span style="font-size: 17pt;">FASLODEX dengan baik dan benar?</span><br /></strong></span></strong></span></p>
<table style="border-collapse: collapse; width: 104.251%; margin-top: 30px; height: 326.219px;" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr style="height: 67.1875px;">
<td style="border-color: #ffffff; text-align: right; width: 41.3948%; height: 119.469px;" rowspan="2"><span style="color: #ec008c; font-family: montserrat;"><span style="font-size: 17pt;"><img src="resources/images/contoh1.png" alt="" width="110" height="126" /></span></span></td>
<td style="padding-left: 15px; padding-top: 15px; border-color: #ffffff; width: 58.5791%; height: 67.1875px; margin: 0px !important;"><span style="font-family: montserrat; font-weight: 800; font-size: 36pt; color: #782b90;">01</span></td>
</tr>
<tr style="height: 52.2812px;">
<td style="width: 58.5791%; border-color: #ffffff; padding-left: 15px; height: 52.2812px; padding-bottom: 35px !important; margin: 0px !important;"><span style="font-family: Raleway; font-size: 14pt;">Jauhkan obat ini dari<br /><span style="font-family: Raleway; font-size: 14pt;">jangkauan anak-anak.</span></span></td>
</tr>
<tr style="height: 67.1875px;">
<td style="border-color: #ffffff; text-align: right; width: 41.3948%; height: 145.609px;" rowspan="2"><span style="color: #ec008c; font-family: montserrat;"><span style="font-size: 17pt;"><img src="resources/images/contoh3.png" alt="" width="110" height="120" /></span></span></td>
<td style="padding-left: 15px; padding-top: 15px; border-color: #ffffff; width: 58.5791%; height: 67.1875px; margin: 0px !important;"><span style="font-family: montserrat; font-weight: 800; font-size: 36pt; color: #782b90;">02</span></td>
</tr>
<tr style="height: 78.4219px;">
<td style="width: 58.5791%; border-color: #ffffff; padding-left: 15px; height: 78.4219px; padding-bottom: 35px !important; margin: 0px !important;"><span style="font-family: Raleway; font-size: 14pt; color: #5f5654;">Jangan menggunakan obat ini<br /><span style="font-family: Raleway; font-size: 14pt; color: #5f5654;">setelah tanggal kadaluarsa<br /><span style="font-family: Raleway; font-size: 14pt; color: #5f5654;">yang tercantum pada kemasan.</span></span></span></td>
</tr>
<tr style="height: 61.1406px;">
<td style="border-color: #ffffff; text-align: right; width: 41.3948%; height: 145.609px;" rowspan="2"><span style="color: #ec008c; font-family: montserrat;"><span style="font-size: 17pt;"><img src="resources/images/contoh2.png" alt="" width="110" height="120" /></span></span></td>
<td style="padding-left: 15px; padding-top: 15px; border-color: #ffffff; width: 58.5791%; height: 67.1875px; margin: 0px !important;"><span style="font-family: montserrat; font-weight: 800; font-size: 36pt; color: #782b90;">03</span></td>
</tr>
<tr>
<td style="width: 58.5791%; border-color: #ffffff; padding-left: 15px; height: 78.4219px; padding-bottom: 35px !important; margin: 0px !important;"><span style="color: #5f5654; font-family: Raleway;"><span style="font-size: 18.6667px;">Simpan obat pada lemari<br />pendingin pada suhu 2 - 8&deg;C.<br />Jangan simpan obat pada suhu<br />di atas 8&deg;C dan di bawah 25&deg;C<br />melebihi 28 hari</span></span></td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>`,
      editorConfig: {
        fontFamily: {
          options: [
            'default',
            'Ubuntu, Arial, sans-serif',
            'Ubuntu Mono, Courier New, Courier, monospace',
          ],
        },
        toolbar: [
          'heading',
          'bulletedList',
          'numberedList',
          'fontFamily',
          'undo',
          'redo',
        ],
      },
      programTypes: [],
    }
  },
  components: {
    editor: Editor,
  },
  watch: {
    articleBody(val) {
      console.log(val)
    },
  },
  created() {
    this.getProgramType()
  },
  methods: {
    async getProgramType() {
      const res = await apiClient.get('/programType')
      this.programTypes = res.data
      // console.log(res.data, '<<<<')
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.submitting = true
          try {
            if (!values.body) values.body = ' '
            console.log('Received values of form: ', values)
            values.image = values.image.file.response.data
            values.bodyHtml = this.articleBody
            if (this.textEditor === 'rte') values.body = ''
            if (this.textEditor === 'ta') values.bodyHtml = null
            values.thumbnailImage = values.thumbnailImage.file.response.data
            const res = await create(values)
            if (res && res.data) {
              notification.success({
                message: 'Sukses',
                description: 'Data berhasil ditambahkan',
                duration: 5,
              })
              router.push('/artikel')
            }
            this.submitting = false
          } catch (e) {
            console.log('This error is', e)
            this.submitting = false
          }
        }
      })
    },
    handleChange(info) {
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      fileList = fileList.map((file) => {
        if (file.response) {
          file.url = file.response.url
        }
        return file
      })

      this.fileList = fileList
    },
    handleChange2(info) {
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      fileList = fileList.map((file) => {
        if (file.response) {
          file.url = file.response.url
        }
        return file
      })

      this.fileList2 = fileList
    },
  },
}
</script>
